module.exports = __webpack_public_path__ + "img/players.2d0018b5.png";